import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OperatorLocksFacadeService} from '@emm/management/services/operator-locks-facade.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'emm-drag-and-drop-file-upload',
    templateUrl: './drag-and-drop-file-upload.component.html',
    styleUrls: ['./drag-and-drop-file-upload.component.scss'],
    standalone: false
})
export class DragAndDropFileUploadComponent {

    @ViewChild('fileDropReference', { static: false }) fileDropElement: ElementRef;
    fileName = '';
    files = [];
    EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fileUploadRef: MatDialogRef<DragAndDropFileUploadComponent>,
        private operatorLocksFacadeService: OperatorLocksFacadeService
    ) { }

    readFileAsFormData(file) {
        const fr = new FileReader();
        let blob: Blob;
        fr.onload = (e) => {
            const arrayBuffer = fr.result as ArrayBuffer;
            blob = new Blob([arrayBuffer], { type: 'multipart/form-data' });
            const formData = new FormData();
            if (file && blob) {
                this.fileName = file.name;
                formData.append('file', blob, file.name);
            }
            this.handleFile(formData);
        }
        fr.readAsArrayBuffer(file);
    }

    onFileDropped(event) {
        const file = event[0];
        this.readFileAsFormData(file);
    }

    onFileSelected(event) {
        const file = event?.target?.files[0];
        this.readFileAsFormData(file);
    }

    closeDialog(): void {
        this.fileUploadRef.close();
    }

    handleFile(file: FormData) {
        this.files.push(file);
        this.fileDropElement.nativeElement.value = null;
    }

    handleFileUpload(): void {
        this.fileUploadRef.close(this.files[0]);
    }

    downloadSampleFile() {
        this.operatorLocksFacadeService.downloadSampleFile().subscribe(fileData => {
            FileSaver.saveAs(fileData.body, 'Operator Lock Items Sample.xlsx');
        });
    }
}
